import { Dispatch, useEffect, useState } from 'react'

import { ModalSuccess } from '@/components/Modal/ModalSuccess/ModalSuccess'
import { CustomTemplateEditor } from '@/components/TextEditor/CustomTemplateEditor'

import { getContentFromCustomCompletePage } from '../../UtilsCompletePage/getContentFromCustomCompletePage'
import { getThemeFromCustomCompletePage } from '../../UtilsCompletePage/getThemeFromCustomCompletePage'
import { upsertCustomCompletePageContentBlock } from '../../UtilsCompletePage/upsertCustomCompletePageContentBlock'
import { CustomIcon } from './CustomIcon'
import { CustomPageTheme } from './CustomPageTheme'

export type StateCustomPageEditorProps = {
  data?: string | null
  setData: Dispatch<React.SetStateAction<string | null | undefined>>
}

type Props = {
  value?: string | null
  onChange?: (value?: string | null) => void
}
export const CustomPageEditor = ({ value, onChange }: Props) => {
  const [data, setData] = useState(value)
  const onChangeContent = (
    input: string | null | undefined,
    content: string
  ) => {
    const newContent = upsertCustomCompletePageContentBlock(input, content)
    setData(newContent)
  }
  const currentTheme = getThemeFromCustomCompletePage(data) || '#51a855'

  useEffect(() => {
    if (data) {
      onChange?.(data)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <ModalSuccess.Root className="relative h-[428px]">
      <div className="relative h-[fit-content] w-full max-w-[468px]">
        <CustomPageTheme {...{ data, setData }} />
        <ModalSuccess.Wrapper className="w-full">
          <ModalSuccess.Bar
            style={{
              backgroundImage: `linear-gradient(118deg, ${currentTheme}, ${currentTheme}75)`,
            }}
          />
          <ModalSuccess.Content className="flex px-0.5 pb-0 pt-1">
            <CustomTemplateEditor
              className="w-full !border-transparent pb-5"
              extraContent={
                <CustomIcon
                  {...{
                    data,
                    setData,
                  }}
                />
              }
              onChange={(value) => onChangeContent(data, value)}
              tools={[
                'bold',
                'italic',
                'strike',
                'underline',
                'bulletList',
                'orderedList',
                'link',
                'left',
                'center',
                'right',
                'size',
              ]}
              value={getContentFromCustomCompletePage(data)}
            />
          </ModalSuccess.Content>
        </ModalSuccess.Wrapper>
      </div>
    </ModalSuccess.Root>
  )
}
